import Notifications from 'react-notification-system-redux';
import { all, call, put, takeEvery, takeLatest } from 'redux-saga/effects';

import { getRequestErrorMessage } from '../../utilities/SagasHelper';
import {
  generateAssignedToWritersReport,
  generateAudioAbbreviationsReport,
  generateAudioReport,
  generateBooksMissingAnswersReport,
  generateFavoriteQuestionsReport as generateFavoriteQuestionsReportServiceCaller,
  generateIntercomActiveUsersReportService,
  generateRateQuestionsReportService,
  generateReferredLeadsReport,
  generateSelfPromotionReport,
  generateSubscriptionTypesReportService,
  generateUsageReportService,
  getAllActiveSubscriptionsReport,
  getAllMasterUserReport,
  getAudioReports,
  getBibliographyReportForGivenRates as getBibliographyReportForGivenRatesServiceCaller,
  getCompletionStatus,
  getFavoriteQuestionsReports as getFavoriteQuestionsReportServiceCaller,
  getLatestAssignedToWritersReport,
  getLatestAudioAbbreviationsReport,
  getLatestBooksMissingAnswersReport,
  getLatestIntercomActiveUsersReportService,
  getLatestReferredLeadsReport,
  getLatestSelfPromotionReport,
  getNumberOfQuestionsEnabledPerRatingExamReport,
  getRateQuestionsReportsService,
  getSubscriptionTypesReportsService,
  getUsageReportsService,
  getUsersCount,
  getUserSubmittedQuestionsReportService,
} from '../../utilities/ServiceManager';
import {
  callUsersCount,
  getBibliographyReportForGivenRatesError,
  getBibliographyReportForGivenRatesSuccess,
  getUsersCountError,
  getUsersCountSuccess,
  setAllActiveSubscriptionsReport,
  setAllActiveSubscriptionsReportLoading,
  setAllMasterUserReport,
  setAllMasterUserReportError,
  setAllMasterUserReportLoading,
  setAssignedToWritersReportData,
  setAssignedToWritersReportStateError,
  setAssignedToWritersReportStateLoading,
  setAssignedToWritersReportStateSuccess,
  setAudioAbbreviationsReport,
  setAudioReportData,
  setAudioReports,
  setAudioReportStateError,
  setAudioReportStateLoading,
  setAudioReportStateSuccess,
  setBooksMissingAnswersReportData,
  setBooksMissingAnswersReportStateError,
  setBooksMissingAnswersReportStateLoading,
  setBooksMissingAnswersReportStateSuccess,
  setIntercomActiveUsersReport,
  setIsLoadingFavoriteQuestionsReport,
  setIsLoadingRateQuestionsReport,
  setIsUserSubmittedQuestionsReportLoading,
  setLastFavoriteQuestionsReport,
  setLastRateQuestionsReport,
  setNumberOfQuestionsEnabledPerRatingExamReport,
  setNumberOfQuestionsEnabledPerRatingExamReportError,
  setReferredLeadsReportData,
  setReferredLeadsReportStateError,
  setReferredLeadsReportStateLoading,
  setReferredLeadsReportStateSuccess,
  setSelfPromotionReportData,
  setSelfPromotionReportStateError,
  setSelfPromotionReportStateLoading,
  setSelfPromotionReportStateSuccess,
  setSubscriptionTypesReports,
  setSubscriptionTypesReportsIsLoading,
  setUsageReports,
  setUsageReportsIsLoading,
  setUserSubmittedQuestionsReport,
  setUserSubmittedQuestionsReportError,
  updateSubscriptionTypesReports,
  updateUsageReports,
} from './actions';
import {
  GENERATE_ASSIGNED_TO_WRITERS_REPORT,
  GENERATE_AUDIO_ABBREVIATIONS_REPORT,
  GENERATE_AUDIO_REPORT,
  GENERATE_BOOKS_MISSING_ANSWERS_REPORT,
  GENERATE_FAVORITE_QUESTIONS_REPORT_FOR_RATES,
  GENERATE_INTERCOM_ACTIVE_USERS_REPORT,
  GENERATE_RATE_QUESTIONS_REPORT,
  GENERATE_REFERRED_LEADS_REPORT,
  GENERATE_SELF_PROMOTION_REPORT,
  GENERATE_SUBSCRIPTION_TYPES_REPORT,
  GENERATE_USAGE_REPORT,
  GET_ALL_ACTIVE_SUBSCRIPTIONS_REPORT,
  GET_ALL_MASTER_USER_REPORT,
  GET_AUDIO_REPORTS,
  GET_BIBLIOGRAPHY_REPORT_FOR_RATES,
  GET_COMPLETION_STATUS,
  GET_LAST_FAVORITE_QUESTIONS_REPORTS,
  GET_LAST_RATE_QUESTIONS_REPORTS,
  GET_LATEST_ASSIGNED_TO_WRITERS_REPORT,
  GET_LATEST_AUDIO_ABBREVIATIONS_REPORT,
  GET_LATEST_BOOKS_MISSING_ANSWERS_REPORT,
  GET_LATEST_INTERCOM_ACTIVE_USERS_REPORT,
  GET_LATEST_REFERRED_LEADS_REPORT,
  GET_LATEST_SELF_PROMOTION_REPORT,
  GET_NUMBER_OF_QUESTIONS_ENABLED_PER_RATING_EXAM_REPORT,
  GET_SUBSCRIPTION_TYPES_REPORTS,
  GET_USAGE_REPORTS,
  GET_USER_SUBMITTED_QUESTIONS_REPORT_FOR_RATES,
  GET_USERS_COUNT,
} from './actionTypes';

function* getBibliographyReportForGivenRates(action) {
  try {
    const csvReport = yield call(
      getBibliographyReportForGivenRatesServiceCaller,
      action.rates,
      action.selectedRatingExams,
      action.multiple,
    );
    yield put(getBibliographyReportForGivenRatesSuccess(csvReport));
  } catch (exception) {
    yield put(getBibliographyReportForGivenRatesError(exception.message));
    yield put(
      showNotificationErrorFromException(
        exception,
        'Could not generate report. Please try again later.',
      ),
    );
  }
}

function* getCompletionStatusSagas() {
  try {
    const completionStatusData = yield call(getCompletionStatus);
  } catch (exception) {
    yield put(
      showNotificationErrorFromException(
        exception,
        'Could not get completion status. Please try again later.',
      ),
    );
  }
}

function* fetchUsersCount(action) {
  try {
    yield put(callUsersCount());
    const usersCountResponse = yield call(getUsersCount, action.query);
    yield put(getUsersCountSuccess(usersCountResponse));
  } catch (exception) {
    yield put(getUsersCountError(exception.message));
    yield put(
      showNotificationErrorFromException(
        exception,
        'Could not get users count from server. Please try again later.',
      ),
    );
  }
}

function* getNumberOfQuestionsEnabledPerRatingExamReportSagas(action) {
  try {
    const numberOfQuestionsPerRatingExamResponse = yield call(
      getNumberOfQuestionsEnabledPerRatingExamReport,
      action.lastRate,
    );
    yield put(
      setNumberOfQuestionsEnabledPerRatingExamReport(
        numberOfQuestionsPerRatingExamResponse,
      ),
    );
  } catch (error) {
    yield put(setNumberOfQuestionsEnabledPerRatingExamReportError());
    yield put(
      Notifications.show(
        {
          title: 'Error',
          message:
            'There was an error getting the report data. Please try again',
        },
        'error',
      ),
    );
  }
}

function* getAllMasterUserReportSagas() {
  try {
    yield put(setAllMasterUserReportLoading(true));
    const getAllMasterUserReportResponse = yield call(getAllMasterUserReport);
    yield put(setAllMasterUserReport(getAllMasterUserReportResponse));
  } catch (error) {
    yield put(setAllMasterUserReportError());
    yield put(
      Notifications.show(
        {
          title: 'Error',
          message:
            'There was an error trying download the Master User Report. Please try again or contact the support',
        },
        'error',
      ),
    );
  } finally {
    yield put(setAllMasterUserReportLoading(false));
  }
}

function* getAllActiveSubscriptionsReportSaga() {
  try {
    yield put(setAllActiveSubscriptionsReportLoading(true));
    const activeSubscriptionsReportResponse = yield call(
      getAllActiveSubscriptionsReport,
    );
    yield put(
      setAllActiveSubscriptionsReport(activeSubscriptionsReportResponse),
    );
  } catch (error) {
    yield put(
      Notifications.show(
        {
          title: 'Error',
          message:
            'There was an error trying download the Master User Report. Please try again or contact the support',
        },
        'error',
      ),
    );
  } finally {
    yield put(setAllActiveSubscriptionsReportLoading(false));
  }
}

function* getUserSubmittedQuestionsReportSagas(action) {
  try {
    yield put(setIsUserSubmittedQuestionsReportLoading(true));
    const response = yield call(
      getUserSubmittedQuestionsReportService,
      action.rates,
    );
    yield put(setUserSubmittedQuestionsReport(response));
  } catch (error) {
    yield put(setUserSubmittedQuestionsReportError(error.message));
    yield put(
      showNotificationErrorFromException(
        exception,
        'Could not generate user submitted questions report. Please try again later.',
      ),
    );
  } finally {
    yield put(setIsUserSubmittedQuestionsReportLoading(false));
  }
}

/* Intercom Active Users Report */
function* getLatestIntercomActiveUsersReportWorker() {
  try {
    const response = yield call(getLatestIntercomActiveUsersReportService);
    yield put(setIntercomActiveUsersReport(response));
  } catch (error) {
    yield put(
      showNotificationErrorFromException(
        error,
        'Could not get the latest Intercom active users report. Please try again later.',
      ),
    );
  }
}
function* generateIntercomActiveUsersReportWorker() {
  try {
    const response = yield call(generateIntercomActiveUsersReportService);
    yield put(setIntercomActiveUsersReport(response));
  } catch (error) {
    yield put(
      showNotificationErrorFromException(
        error,
        'Could not generate Intercom active users report. Please try again later.',
      ),
    );
  }
}

/* Favorite Questions Report */
function* generateFavoriteQuestionsReport(action) {
  try {
    const response = yield call(
      generateFavoriteQuestionsReportServiceCaller,
      action.ratesIds,
      action.selectedRatingExams,
    );
    // set all rates selected how loading
    yield put(setIsLoadingFavoriteQuestionsReport(action.ratesIds));
    yield put(
      Notifications.show(
        {
          title: 'Done!',
          message: response.message,
          autoDismiss: 5,
        },
        'success',
      ),
    );
  } catch (exception) {
    yield put(
      showNotificationErrorFromException(
        exception,
        'Could not generate favorite questions report. Please try again later.',
      ),
    );
  }
}
function* getFavoriteQuestionsReports() {
  try {
    const response = yield call(getFavoriteQuestionsReportServiceCaller);
    yield put(setLastFavoriteQuestionsReport(response));
  } catch (exception) {
    yield put(
      showNotificationErrorFromException(
        exception,
        'Could not get favorite questions reports. Please try again later.',
      ),
    );
  }
}

/* Rate Questions Report */
function* generateRateQuestionsReport(action) {
  try {
    const response = yield call(
      generateRateQuestionsReportService,
      action.ratesIds,
    );
    // set all rates selected how loading
    yield put(setIsLoadingRateQuestionsReport(action.ratesIds));

    yield put(
      Notifications.show(
        {
          title: 'Done!',
          message: response.message,
          autoDismiss: 5,
        },
        'success',
      ),
    );
  } catch (err) {
    yield put(
      showNotificationErrorFromException(
        err,
        'Error generating AFSC questions report',
      ),
    );
  }
}
function* getRateQuestionsReports() {
  try {
    const response = yield call(getRateQuestionsReportsService);
    yield put(setLastRateQuestionsReport(response));
  } catch (err) {
    yield put(showNotificationErrorFromException(err, 'Error'));
  }
}

/* Usage Report */
function* generateUsageReportSaga(action) {
  try {
    const response = yield call(
      generateUsageReportService,
      action.fromDate,
      action.untilDate,
      action.fromDateComparison,
      action.untilDateComparison,
    );

    yield put(updateUsageReports(response));

    yield put(
      Notifications.show(
        {
          title: 'Work in progress',
          message: `Usage report generation started in the background.`,
        },
        'success',
      ),
    );
  } catch (err) {
    yield put(showNotificationErrorFromException(err, 'Error'));
  }
}
function* getUsageReports() {
  try {
    yield put(setUsageReportsIsLoading(true));
    const response = yield call(getUsageReportsService);
    yield put(setUsageReports(response));
  } catch (err) {
    yield put(showNotificationErrorFromException(err, 'Error'));
  } finally {
    yield put(setUsageReportsIsLoading(false));
  }
}

/* Subscription Types Report */
function* generateSubscriptionTypesReportSaga(action) {
  try {
    const response = yield call(
      generateSubscriptionTypesReportService,
      action.fromDate,
      action.untilDate,
      action.fromDateComparison,
      action.untilDateComparison,
    );

    yield put(updateSubscriptionTypesReports(response));

    yield put(
      Notifications.show(
        {
          title: 'Work in progress',
          message: `Subscription types report generation started in the background.`,
        },
        'success',
      ),
    );
  } catch (err) {
    yield put(showNotificationErrorFromException(err, 'Error'));
  }
}

function* getSubscriptionTypesReports() {
  try {
    yield put(setSubscriptionTypesReportsIsLoading(true));
    const response = yield call(getSubscriptionTypesReportsService);
    yield put(setSubscriptionTypesReports(response));
  } catch (err) {
    yield put(showNotificationErrorFromException(err, 'Error'));
  } finally {
    yield put(setSubscriptionTypesReportsIsLoading(false));
  }
}

/* Books missing answers report */
function* handleBooksMissingAnswersReportSaga(action) {
  let response = {};
  try {
    yield put(setBooksMissingAnswersReportStateLoading());
    if (action.type === GENERATE_BOOKS_MISSING_ANSWERS_REPORT) {
      response = yield call(generateBooksMissingAnswersReport);
    } else if (action.type === GET_LATEST_BOOKS_MISSING_ANSWERS_REPORT) {
      response = yield call(getLatestBooksMissingAnswersReport);
    }
    yield put(setBooksMissingAnswersReportData(response));
    yield put(setBooksMissingAnswersReportStateSuccess());
  } catch (error) {
    yield put(setBooksMissingAnswersReportStateError());
  }
}

/* Audio Report */
function* getAudioReportsWorker() {
  const response = yield call(getAudioReports);
  yield put(setAudioReports(response));
}

function* generateAudioReportWorker(action) {
  try {
    yield put(setAudioReportStateLoading(action.payload));
    const response = yield call(generateAudioReport, action.payload);
    yield put(setAudioReportData(response));
    yield put(setAudioReportStateSuccess(action.payload));
  } catch {
    yield put(setAudioReportStateError(action.payload));
  }
}

/* Audio Abbreviations Report */
function* getLatestAudioAbbreviationsReportWorker() {
  try {
    const response = yield call(getLatestAudioAbbreviationsReport);
    yield put(setAudioAbbreviationsReport(response));
  } catch (error) {
    yield put(
      showNotificationErrorFromException(
        error,
        'Could not get the latest audio abbreviations report. Please try again later.',
      ),
    );
  }
}
function* generateAudioAbbreviationsReportWorker() {
  try {
    const response = yield call(generateAudioAbbreviationsReport);
    yield put(setAudioAbbreviationsReport(response));
  } catch (error) {
    yield put(
      showNotificationErrorFromException(
        error,
        'Could not generate audio abbreviations report. Please try again later.',
      ),
    );
  }
}

/* Referred Leads Report */
function* handleReferredLeadsReportSaga(action) {
  let response = {};
  try {
    yield put(setReferredLeadsReportStateLoading());
    if (action.type === GENERATE_REFERRED_LEADS_REPORT) {
      response = yield call(generateReferredLeadsReport);
    } else if (action.type === GET_LATEST_REFERRED_LEADS_REPORT) {
      response = yield call(getLatestReferredLeadsReport);
    }
    yield put(setReferredLeadsReportData(response));
    yield put(setReferredLeadsReportStateSuccess());
  } catch (error) {
    yield put(setReferredLeadsReportStateError());
  }
}

/* Assigned to Writers Report */
function* handleAssignedToWritersReportSaga(action) {
  let response = {};
  try {
    yield put(setAssignedToWritersReportStateLoading());

    if (action.type === GENERATE_ASSIGNED_TO_WRITERS_REPORT) {
      response = yield call(generateAssignedToWritersReport);
    } else if (action.type === GET_LATEST_ASSIGNED_TO_WRITERS_REPORT) {
      response = yield call(getLatestAssignedToWritersReport);
    }

    yield put(setAssignedToWritersReportData(response));
    yield put(setAssignedToWritersReportStateSuccess());
  } catch (error) {
    yield put(setAssignedToWritersReportStateError());
  }
}

/* Self Promotion Status Report */
function* handleSelfPromotionReportSaga(action) {
  let response = {};
  try {
    yield put(setSelfPromotionReportStateLoading());
    if (action.type === GENERATE_SELF_PROMOTION_REPORT) {
      response = yield call(generateSelfPromotionReport);
    } else if (action.type === GET_LATEST_SELF_PROMOTION_REPORT) {
      response = yield call(getLatestSelfPromotionReport);
    }
    yield put(setSelfPromotionReportData(response));
    yield put(setSelfPromotionReportStateSuccess());
  } catch (error) {
    yield put(setSelfPromotionReportStateError());
  }
}

export default function* sagas() {
  all([
    yield takeLatest(
      GENERATE_SUBSCRIPTION_TYPES_REPORT,
      generateSubscriptionTypesReportSaga,
    ),
    yield takeLatest(
      GET_SUBSCRIPTION_TYPES_REPORTS,
      getSubscriptionTypesReports,
    ),
    yield takeLatest(
      GET_BIBLIOGRAPHY_REPORT_FOR_RATES,
      getBibliographyReportForGivenRates,
    ),
    yield takeLatest(
      GENERATE_FAVORITE_QUESTIONS_REPORT_FOR_RATES,
      generateFavoriteQuestionsReport,
    ),
    yield takeLatest(
      GET_LAST_FAVORITE_QUESTIONS_REPORTS,
      getFavoriteQuestionsReports,
    ),
    yield takeLatest(GET_USERS_COUNT, fetchUsersCount),
    yield takeLatest(GET_ALL_MASTER_USER_REPORT, getAllMasterUserReportSagas),
    yield takeLatest(
      GET_ALL_ACTIVE_SUBSCRIPTIONS_REPORT,
      getAllActiveSubscriptionsReportSaga,
    ),
    yield takeLatest(GET_COMPLETION_STATUS, getCompletionStatusSagas),
    yield takeLatest(
      GET_NUMBER_OF_QUESTIONS_ENABLED_PER_RATING_EXAM_REPORT,
      getNumberOfQuestionsEnabledPerRatingExamReportSagas,
    ),
    yield takeLatest(
      GET_USER_SUBMITTED_QUESTIONS_REPORT_FOR_RATES,
      getUserSubmittedQuestionsReportSagas,
    ),
    yield takeLatest(
      GET_LATEST_INTERCOM_ACTIVE_USERS_REPORT,
      getLatestIntercomActiveUsersReportWorker,
    ),
    yield takeLatest(
      GENERATE_INTERCOM_ACTIVE_USERS_REPORT,
      generateIntercomActiveUsersReportWorker,
    ),
    yield takeLatest(
      GENERATE_RATE_QUESTIONS_REPORT,
      generateRateQuestionsReport,
    ),
    yield takeLatest(GET_LAST_RATE_QUESTIONS_REPORTS, getRateQuestionsReports),
    yield takeLatest(GENERATE_USAGE_REPORT, generateUsageReportSaga),
    yield takeLatest(GET_USAGE_REPORTS, getUsageReports),
    yield takeLatest(
      [
        GENERATE_BOOKS_MISSING_ANSWERS_REPORT,
        GET_LATEST_BOOKS_MISSING_ANSWERS_REPORT,
      ],
      handleBooksMissingAnswersReportSaga,
    ),
    yield takeLatest(GET_AUDIO_REPORTS, getAudioReportsWorker),
    yield takeEvery(GENERATE_AUDIO_REPORT, generateAudioReportWorker),
    yield takeLatest(
      GET_LATEST_AUDIO_ABBREVIATIONS_REPORT,
      getLatestAudioAbbreviationsReportWorker,
    ),
    yield takeLatest(
      GENERATE_AUDIO_ABBREVIATIONS_REPORT,
      generateAudioAbbreviationsReportWorker,
    ),
    yield takeLatest(
      [GENERATE_REFERRED_LEADS_REPORT, GET_LATEST_REFERRED_LEADS_REPORT],
      handleReferredLeadsReportSaga,
    ),
    yield takeLatest(
      [
        GENERATE_ASSIGNED_TO_WRITERS_REPORT,
        GET_LATEST_ASSIGNED_TO_WRITERS_REPORT,
      ],
      handleAssignedToWritersReportSaga,
    ),
    yield takeLatest(
      [GENERATE_SELF_PROMOTION_REPORT, GET_LATEST_SELF_PROMOTION_REPORT],
      handleSelfPromotionReportSaga,
    ),
  ]);
}

function showNotificationErrorFromException(exception, optionalMessage) {
  const message = optionalMessage || getRequestErrorMessage(exception);
  return Notifications.show({ title: 'Ops!', message }, 'error');
}
